import { Component } from '@angular/core';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccessDoorTypeService } from '../../services/access-door-type.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-access-door-type-modal',
  templateUrl: './access-door-type-modal.component.html',
  styleUrl: './access-door-type-modal.component.scss'
})
export class AccessDoorTypeModalComponent {

  public dataForm: DataFormModel = {
    accessDoorType: {
      value: '',
      type: 'text',
      label: 'Tipo de puerta',
      requiredMessage: 'Por favor, ingrese el tipo de puerta (máx. 15 caracteres)',
      required: true,
      validators: [Validators.required, Validators.maxLength(15)]
    }
  };

  public submitted: boolean = false;
  public loading: boolean = false;
  public formAccessDoorType!: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    public accessDoorTypeService: AccessDoorTypeService,
    public utilService: UtilService,
  ) {}

  ngOnInit(): void {
    this.formAccessDoorType = this.utilService.buildForm(this.dataForm);
  }

  get f() {
    return this.formAccessDoorType.controls;
  }

  async onSubmit() {
    this.submitted = true;
    if (this.formAccessDoorType.invalid) return;
    await this.create();
  }

  async create() {
    const flag = await this.accessDoorTypeService.create(this.formAccessDoorType.value);
    if (flag) {
      this.activeModal.close();
    }
  }
}
